<template>
  <div>


    <SushiStoreBanner :store="store" v-if="!isWC() && store && sushiHub" />



    <div
        v-if="!isWC() && store && !sushiHub"
        :style="{ 'background-image': 'url(' + store.ProfileImage + ')' }"
        class="banner text-white position-relative"
    >
      <div class="company-details">
        <router-link v-if="store.Logo && showLogo" :to="geyHomePageUrl">
          <img :src="store.Logo" alt="logo" @error="showLogoError" />
        </router-link>
        <h2 v-show="store.StoreTitle">{{ store.StoreTitle }}</h2>
        <h5 v-show="!isGift" class="store-name">
          {{ store.Name }}
          <router-link
              v-if="showChangeStore"
              to="/"
          >
            <span class="change-store">[{{ $t("message.changeStore") }}]</span>
          </router-link>
        </h5>
        <h5 v-if="store.Location">
          {{ store.Location.Address }}
          {{
            (store.Location.Suburb || "") +
            " " +
            (store.Location.State || "") +
            " " +
            (store.Location.Postcode || "")
          }}
        </h5>
        <h5 v-if="store.OfficePhone">{{ store.OfficePhone }}</h5>
        <div v-if="!isGift && getloadedMenu">
          <h6 v-if="opening && (opening.openTime || opening.closeTime)">
            {{ $t("message.open") }}
            <span>{{ opening.openTime }}</span>
            {{ $t("message.toName") }}
            <span>{{ opening.closeTime }}</span>
          </h6>
          <h6 v-else-if="!isEnablePreOrder">{{ $t("message.closedToday") }}</h6>
        </div>
      </div>
    </div>


  </div>
</template>

<script>
import {
  operatingHours,
  getCurrentDate
} from "../../../api/helpers/datetimeHelper.js";
import { mapGetters } from "vuex";
import SushiStoreBanner from "@/components/sushiHub/sushiStoreBanner";
export default {
  name: "ShopHeader",
  components: {SushiStoreBanner},
  props: {
    storeId: {
      type: String,
      default: ""
    },
    sushiHub: {
      type: Boolean
    }
  },
  data() {
    return {
      showLogo: true,
      store: {}
    };
  },
  mounted() {
    this.store = this.selectedCompany
        ? this.selectedCompany
        : this.currentStoreDoc;
    //console.log("stire ", this.store)
  },
  watch: {
    selectedCompany() {
      this.store = this.selectedCompany
          ? this.selectedCompany
          : this.currentStoreDoc;
    },
    currentStoreDoc() {
      this.store = this.selectedCompany
          ? this.selectedCompany
          : this.currentStoreDoc;
    }
  },
  computed: {
    ...mapGetters([
      "isGift",
      "getloadedMenu",
      "currentStoreDoc",
      "selectedCompany"
    ]),
    opening() {
      if (this.store.OperatingHours) {
        var now = getCurrentDate(this.store.TimezoneIanaFormat);
        return operatingHours(this.store.BlackoutDates, now, this.store.OperatingHours);
      } else {
        return null;
      }
    },
    geyHomePageUrl() {
      return this.isGift
          ? "/store/" + this.currentStoreDoc.ID + "/giftcards"
          : "/store/" + this.currentStoreDoc.ID;
    },
    isEnablePreOrder() {
      return (
          this.selectedCompany.IsInOperation &&
          (this.selectedCompany.EnablePreoderForDelivery ||
              this.selectedCompany.EnablePreoderForPickup)
      );
    },
    showChangeStore() {
      return (!this.isGift || !this.isWC() || !this.isRootPath())&& this.currentStoreDoc.IsHQ;
    },
  },
  methods: {
    showLogoError() {
      this.showLogo = false;
    },
    getOperatingHours(storedoc) {
      var now = getCurrentDate(storedoc.TimezoneCity);
      return operatingHours(storedoc.BlackoutDates, now, storedoc.OperatingHours);
    },
  }
};
</script>
